<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>远程预付费</el-breadcrumb-item>
			<el-breadcrumb-item>银行账户管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search" @submit.native.prevent>
      <el-form-item label="搜索：">
      <el-input placeholder="请输入房间编号" @keyup.enter.native="search" v-model="formInline.meterPointName" size="small"></el-input>
      </el-form-item>
      <el-form-item v-if="user.username == 'admin'">
      	<el-select v-model="formInline.depId" placeholder="请选择" @change="handleNodeClick" size="small">
      	   <el-option
      	     v-for="item in treeDate"
      	     :key="item.id"
      	     :label="item.departmentName"
      	     :value="item.id">
      	   </el-option>
      	 </el-select>
      </el-form-item>
			<el-form-item >
				<el-input placeholder="请输入用户账号" @keyup.enter.native="search" v-model="formInline.username" size="small"></el-input>
			</el-form-item>

			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				<prems-button size="small" type="primary" icon="el-icon-circle-plus-outline" perms="cuser:add" @click="handleEdit"
				 label="添加" />
			</el-form-item>

		</el-form>

		<!--列表-->
		<el-table size="small" :data="listData" @selection-change="handleSelectionChange" :header-cell-style="this.$store.state.headerCss" :max-height="tableHeight" highlight-current-row v-loading="loading"
		 border element-loading-text="拼命加载中" style="width: 100%;" stripe>
			<el-table-column align="center" type="selection" width="60">
			</el-table-column>
      <el-table-column  label="公司地址" prop="companyAddress"  >
      </el-table-column>
      <el-table-column  label="银行账号" prop="idCard"  >
      </el-table-column>
			<el-table-column label="银行地址" prop="bankAddress" >
			</el-table-column>
			<el-table-column prop="createDate" label="创建时间" show-overflow-tooltip >
			</el-table-column>


			<el-table-column align="center" label="操作" width="260">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<!-- <prems-button size="mini" @click="handleEdit(scope.$index, scope.row)" perms="cusr:detail" label="编辑" /> -->
          <el-button size="mini" type="primary" @click="handelMeter(scope.row)">绑定计量点</el-button>
					<el-button size="mini" type="danger" @click="deleteInfo(scope.$index, scope.row)">删除</el-button>
					<!-- <prems-button size="mini" type="danger"  perms="cuser:delete" @click="deleteInfo(scope.$index, scope.row)" label="删除" /> -->
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather" v-if="showPage"></Pagination> -->


		<el-dialog :title="title" :visible.sync="editFormVisible" width="35%" @click="closeDialog" :close-on-click-modal="false">
			<el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item v-if="user.username == 'admin'"  label="请选择部门">
        	<el-select v-model="formInline.depId" placeholder="请选择" @change="deptChange" size="small">
        	   <el-option
        	     v-for="item in treeDate"
        	     :key="item.id"
        	     :label="item.departmentName"
        	     :value="item.id">
        	   </el-option>
        	 </el-select>
        </el-form-item>
        <el-form-item label="公司地址" >
					<el-input size="small" v-model="editForm.companyAddress" auto-complete="off" placeholder="请输入公司地址"></el-input>
				</el-form-item>

				<el-form-item label="银行账号" prop="idCard">
					<el-input size="small" v-model="editForm.idCard" auto-complete="off" placeholder="请输入银行账号"></el-input>
				</el-form-item>
				<el-form-item label="银行地址" prop="bankAddress">
					<el-input size="small" v-model="editForm.bankAddress" auto-complete="off" placeholder="请输入银行地址"></el-input>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeDialog">取消</el-button>
				<el-button size="small" type="primary" :loading="setLoading" class="title" @click="submitForm('editForm')">保存</el-button>
			</div>
		</el-dialog>

    <el-dialog title="绑定计量点" :visible.sync="bindVsisbel" width="50%":close-on-click-modal="false">
      <div>
        <el-button type="danger"  :loading="loadBind" :disabled="deleMeters.length == 0" @click="removeMeters" size="small">删除</el-button>
        <el-button type="primary" size="small" @click="handelAddMeter">添加</el-button>
      </div>
      <div style="line-height: 30px;">当前绑定的计量点</div>
      <el-table size="small" :data="meters" height="500px" border  @selection-change="getDelMeterIds">
      	<el-table-column type="selection"></el-table-column>

      	<el-table-column label="计量点名称" prop="meterPointName" sortable></el-table-column>
      	<el-table-column label="计量点通迅地址" prop="meterPoint"></el-table-column>

      </el-table>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="bindVsisbel = false">取消</el-button>
    		<!-- <el-button size="small" type="primary" :loading="setLoading" class="title" @click="bindMeter">保存</el-button> -->
    	</div>
    </el-dialog>


    <el-dialog title="选择计量点"  :visible.sync="meterVisibel" width="50%":close-on-click-modal="false">
      <el-form inline>
        <el-form-item label="搜索">
          <el-input v-model="meterForm.meterPointName" size="small"></el-input>
        </el-form-item>
        <el-form-item >
          <el-button @click="getMeterByDeptId" size="small" type="primary">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="loadMeter" size="small" :data="meterList" height="500px" border  @selection-change="getMeterIds">
      	<el-table-column type="selection"></el-table-column>

      	<el-table-column label="计量点名称" prop="meterPointName" sortable></el-table-column>
      	<el-table-column label="计量点通迅地址" prop="meterPoint"></el-table-column>

      </el-table>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="meterVisibel = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="loadBind" class="title" @click="bindMeter">保存</el-button>
    	</div>
    </el-dialog>



	</div>
</template>

<script>
	import Pagination from '../../components/Pagination'
	import PremsButton from "@/views/permission/PreButtom";
	import {
		saveOrUpdateBankAccount,
    findBankAccountList,
    BankAccountDelete,
    findMeterIdByDeptId,
    findMeterIdByBankId,
    addBankAccountMeterInfo,
    removeBankAccountMeterInfo
	} from '../../api/payMG.js'

  import { getDepartmentTerminalInfoLis,getTerminalInfoByDepId } from '../../api/energyMG'
	export default {
		data() {
			 var validatePass = (rule, value, callback) => {

				if (this.selectDatas.length === 0) {
				  callback(new Error('请选择房间'));
				} else {

				  callback();
				}
			  };
			return {
				downloadLoadin:false,
        user:{},
        getJZ:"",
        tableHeight:0,
				showPage:true,
				formInline: {
          depId:""
				},
        loadBind:false,
        meterIds:"",
        meterForm:{
          deptId:"",
          meterPointName:""
        },
        treeDate:[],
        meterVisibel:false,
				userType:"1",
				editForm: {
          idCard:"",
					bankAddress: "",
          dptId:'',
          companyAddress:"",
				},
        cruDeptId:"",
        meters:[],
        meterList:[],
        bindVsisbel:false,
				roomList: [],
				allRoomList:[],
				noBindRoomList:[],
				listData: [],
				selectDatas:[],
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
        loadMeter:false,

        curId:"",
				// rules表单验证
				rules: {
					username: [{
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					}],
					phoneNumber: [{
					  pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
					  required: true,
					  message: '请输入正确的手机号',
					  trigger: 'blur'

					}],
					roomNum:[{validator:validatePass,trigger:'change' }]

				},
				title: "添加",
				editFormVisible: false,
				loadLoadin: false,
				loading: false,
				setLoading:false,
        deleMeters:[],
			}
		},
		components: {
			Pagination,
			PremsButton
		},
    mounted(){
      this.$nextTick(() => {

      	this.tableHeight = window.innerHeight - 300
      })
    },
		created(){
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.formInline.depId = this.user.departmentId
      this.getJZ = this.user.departmentName
      this.getJzData();

		},
		methods: {

			handleSelectionChange() {

			},
      deptChange(e){
        this.editForm.dptId = e
      },

      handleNodeClick(data){
        this.formInline.depId = data
        this.editForm.dptId  = data
        this.search()
      },

      handelMeter(row){
        this.curId = row.id
        this.cruDeptId = row.departMentId
        this.meterForm.deptId = row.departMentId
        this.bindVsisbel = true
        this.getMeterByBankId()
      },

      handelAddMeter(){
        this.meterVisibel = true
        this.getMeterByDeptId()
      },

      getMeterByBankId(){
        this.loadMeter = true
        findMeterIdByBankId({ bankId:this.curId}).then(res => {
          this.loadMeter = false
          if(res.status == 1){
            this.meters = res.data || []
          }else{
            this.$message.error(res.msg)
          }

        })
      },
      getMeterByDeptId(){
        this.loadMeter = true
        findMeterIdByDeptId(this.meterForm).then(res => {
          this.loadMeter = false
          if(res.status == 1){
            this.meterList = res.data || []
          }else{
            this.$message.error(res.msg)
          }

        })
      },

      getMeterIds(e){
        this.meterIds = e.map(item => item.meterId).join(',')
      },




      bindMeter(){
        this.loadBind = true
        let parm = {
          bankId:this.curId,
          meterIds:this.meterIds
        }

        addBankAccountMeterInfo(parm).then(res => {
          this.loadBind = false
          if(res.status == 1){
            this.$message.success('操作成功！')
            this.meterVisibel = false
            this.getMeterByBankId()
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      getDelMeterIds(e){
        this.deleMeters = e
        console.log(this.deleMeters)
      },


      removeMeters(){
        this.loadBind = true
        let parm = {
          meterIds:this.deleMeters.map(item => item.meterInfoId).join(',')
        }
        removeBankAccountMeterInfo(parm).then(res => {
          this.loadBind = false
          if(res.status == 1){
            this.$message.success('操作成功！')
            this.meterVisibel = false
            this.getMeterByBankId()
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      //获取集中器信息
      getJzData:function(){
      	return new Promise((resolve,reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if(res.status == 1){
      				let arr = []
      				this.treeDate = res.data.menuDepList
              this.formInline.depId = res.data.menuDepList[0].id
              this.editForm.dptId = res.data.menuDepList[0].id
              this.getdata()
      			}
      			else{
      				this.$message.error(res.msg)
      			}
      		})
      	})
      },



			//显示编辑界面
			handleEdit: function(index, row) {
				this.editFormVisible = true
				if (row != undefined && row != 'undefined') {
					this.title = '修改'
          this.editForm.bankAddress = row.bankAddress
          this.editForm.idCard = row.idCard
          this.editForm.dptId = row.departMentId
          this.editForm.id = row.id
          this.editForm.companyAddress = row.companyAddress
				} else {
					this.title = '添加'
          this.editForm.id = ''
          this.editForm.dptId = this.formInline.depId
					this.editForm.bankAddress = ""
          this.editForm.companyAddress = ''
					this.editForm.idCard = ""
				}

			},
			// 编辑、增加页面保存方法
			submitForm(editData) {
				this.$refs[editData].validate(valid => {
					if (valid) {
            this.saveData();
					} else {
						return false
					}
				})
			},
			onGetRoom(e){
				this.editForm.meterInfoIds = e.join('-')

			},

			// 关闭编辑、增加弹出框
			closeDialog() {
				this.editFormVisible = false
			},
			search() {
				this.pageparm.currentPage = 1
				this.formInline.currentPage = 1
				this.showPage = false

				this.getdata();
				 this.$nextTick(() => {
					this.showPage = true
				})
			},
			// 分页插件事件
			callFather(parm) {
				this.formInline.currentPage = parm.currentPage
				this.formInline.pageSize = parm.pageSize
				this.getdata(this.formInline)
			},

			getdata(){

				this.loading = true
				 findBankAccountList(this.formInline).then(res => {
				  this.loading = false
				  if (res.status == 1) {
						this.listData = res.data

				  } else {
				    this.$message({
				      type: 'info',
				      message: res.msg
				    })
				  }
				})
				.catch(err => {
				  this.editFormVisible = false
				  this.loading = false
				  this.$message.error('获取数据失败，请稍后再试！')
				})
			},


			getAllRoomList(){
				findAllMeterInfoList().then(res => {
					if (res.status == 1) {
						this.allRoomList = res.data
					} else {
						this.$message({
							type: 'info',
							message: res.msg
						})
					}
				})
				.catch(err => {
					this.editFormVisible = false
					this.loading = false
					this.$message.error('获取房间数据失败，请稍后再试！')
				})
			},

			saveData() {
				this.setLoading = true

				saveOrUpdateBankAccount(this.editForm)
					.then(res => {
						this.setLoading = false

						if (res.status == 1) {
              this.editFormVisible = false

							this.$message({
								type: 'success',
								message: '操作成功！'
							})
              this.getdata()

						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
					.catch(err => {
						this.editFormVisible = false
						this.setLoading = false
						this.$message.error('添加失败，请稍后再试！')
					})
			},

			 // 删除
			deleteInfo(index, row) {
			  this.$confirm('确定要删除吗?', '信息', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  })
			    .then(() => {
			      // 删除
			      BankAccountDelete({ Id:row.id})
			        .then(res => {
			          if (res.status == 1) {
			            this.$message({
			              type: 'success',
			              message: '已删除!'
			            })

			            this.getdata()
			          } else {
			            this.$message({
			              type: 'info',
			              message: res.msg
			            })
			          }
			        })
			        .catch(err => {

			          this.$message.error('删除失败，请稍后再试！')
			        })
			    })
			    .catch((e) => {
            console.log(e)
			      this.$message({
			        type: 'info',
			        message: '已取消删除！'
			      })
			    })
			},
		},
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/prepayment/bankInfo.vue